// extracted by mini-css-extract-plugin
module.exports = {"label":"SliderInput_label__1m00p","image":"SliderInput_image__ODJhF","sliderContainer":"SliderInput_sliderContainer__3Af6O","slider":"SliderInput_slider__3YsD9"};